import JInspectorRow from './JInspectorRow';
import { emsToDisplay } from '../../../services/utils/DateFormat';

/**
 * JInspectorReadonly — separator + readonly fields (RK, Tid, Created, Updated).
 * @param {object} entry - current entry object
 */
export default function JInspectorReadonly({ entry }) {
    return (
        <>
            <div className="j-inspector-separator" />
            <JInspectorRow label="RK" value={entry?.rk} readonly tooltip="Unique entry identifier — use this to reference the entry in API calls" />
            <JInspectorRow label="Created" value={emsToDisplay(entry?.ems)} readonly />
            <JInspectorRow label="Updated" value={emsToDisplay(entry?.updatedOn)} readonly />
        </>
    );
}
